import { useTranslation } from 'react-i18next';
import { SectionToolbar } from 'src/components/SectionToolbar';
import { Filters } from 'src/shared/Filters/Filters';
import { LocationFilter } from 'src/shared/Filters/LocationFilter';
import { PackageCategoryFilter } from 'src/shared/Filters/PackageCategoryFilter';
import { ProductTagFilter } from 'src/shared/Filters/ProductTagFilter';

interface ItemFiltersProps {
  params: any;
  updateParam: (key: string, value: any) => void;
  updateFilterParam: (key: string, value: any) => void;
  getFilterParamValue: (key: string) => any;
  resetFilterParams: () => void;
  selectedItemType?: string | null;
}

const ItemFilters = ({
  params,
  updateParam,
  updateFilterParam,
  getFilterParamValue,
  resetFilterParams,
  selectedItemType,
}: ItemFiltersProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'client.payment' });

  const filters = [
    {
      field: 'packageCategory',
      label: t('packageCategories'),
      Component: PackageCategoryFilter,
      hideFromToolbar: selectedItemType !== 'package',
    },
    {
      field: 'packageLocation',
      label: t('packageLocation'),
      Component: LocationFilter,
      hideFromToolbar: selectedItemType !== 'package',
    },
    {
      field: 'productTag',
      label: t('productTags'),
      Component: ProductTagFilter,
      hideFromToolbar: selectedItemType !== 'product',
    },
  ];

  const visibleFilters = filters.filter((filter) => !filter.hideFromToolbar);

  return visibleFilters.length > 0 ? (
    <SectionToolbar sx={{ px: 0, pb: 1, pt: 0 }}>
      <Filters
        hideMainDropdown
        filters={visibleFilters}
        params={params}
        updateParam={updateParam}
        updateFilterParam={updateFilterParam}
        getFilterParamValue={getFilterParamValue}
        resetFilterParams={resetFilterParams}
      />
    </SectionToolbar>
  ) : null;
};

export default ItemFilters;
